import React from "react"

const StepZero = props => {
  const { setActualStep, setShowWinSample, params, randomKey } = props

  return (
    <div
      className="banner"
      onClick={e => {
        setActualStep(1)
        setShowWinSample(true)
      }}
    >
      {Array.isArray(params.bannerInternaMuestreo) &&
        params.bannerInternaMuestreo.map(banner => {
          if (banner.title && /-desktop/g.test(banner.title)) {
            return (
              <img
                key={randomKey()}
                className="banner-web"
                src={params.bannerInternaMuestreo[0].file.url}
              />
            )
          } else if (banner.title && /-mobile/g.test(banner.title)) {
            return (
              <img
                key={randomKey()}
                className="banner-mov"
                src={params.bannerInternaMuestreo[1].file.url}
              />
            )
          }
        })}
    </div>
  )
}

export default StepZero
